(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name commons.service:SlideInPanelService
     *
     * @description
     *
     */
    angular
        .module('commons')
        .service('SlideInPanelService', SlideInPanelService);

    function SlideInPanelService(panels, EventManagerService) {
        var self = this;

        var panelData = {};

        var setData = function (panelName, data) {
            panelData[panelName] = data;
                EventManagerService.notifyEventListeners(EventManagerService.EVENT.PANEL.DATA_CHANGED,panelName);
        };

        self.getData = function (panelName) {
            return panelData[panelName];
        };

        self.toggle = function (panelID, data) {
            if (panels.opened == panelID) {
                panels.close(panelID);
            } else {
                panels.open(panelID);
                self.setData(panelID, data);
            }
        };

        self.openPanel = function (panelID, data) {
            panels.open(panelID);
            setData(panelID, data);
        };

        self.closeAllPanels = function () {
            angular.forEach(Object.keys(panelData), function (panelId) {
                panels.close(panelId);
            })
        }
    }
}());
